<template>
  <div>
    <!-- <div style="width:500px;">
      {{ farmData }}
    </div> -->
    <div class="cd-info" v-show="farmData.farm_code">{{ farmData.farm_code }}</div>

    <v-select dense outlined 
      id="company" 
      ref="companySelect" 
      label="경영체✽" 
      v-model="farmData.company"
      :items="companyItems"
      :menu-props="{ top: false, offsetY: true }"
      item-text="name"
      return-object
      @change="updateSelectedCompany"
    />
   
    <div class="mt-2 flex">
      <v-select dense outlined 
        id="bizstatus" 
        ref="bizstatus" 
        class="selectmin"
        label="축종✽" 
        v-model="farmData.bizstatus"
        :items="bizstatusItems"
        :menu-props="{ top: false, offsetY: true }"
        item-text="name"
        return-object
      />
      <v-text-field dense outlined 
        class="textfield"
        id="farm_name" 
        ref="farm_name" 
        :label="['CF02', 'CF04', 'CF05', 'CF06'].includes(farmData.bizstatus.code) ? '농장명✽' : '사업장명✽'"
        v-model="farmData.farm_name" 
      />
      <v-checkbox
        v-model="sameInfo"
        color="#005B96"
        style="margin-top:-5px;"
        label="경영체와 동일"
        @change="check()"
      />
    </div>
   
    <div class="mt-2 flex">
      <v-select dense outlined v-if="farmData.bizstatus.code == 'CF02'"
        v-model="farmData.biz_structure" 
        ref="biz_structure" 
        class="selectmin biz_text"
        style="width:110px;"
        label="경영형태*"
        :items="['일관경영','번식경영1 (번식‣분만)','번식경영2 (번식‣분만‣새끼)','비육경영1 (새끼‣비육)','비육경영2 (비육)']"
        item-text="name"
        :menu-props="{ top: false, offsetY: true }"
        return-object
      />
      <v-text-field dense outlined 
        class="textfield"
        id="business_no" 
        ref="business_no"
        label="사업자번호/법인번호" 
        placeholder="사업자 또는 법인 등록번호의 숫자만 입력"
        v-model="farmData.business_no" 
        @keyup="farmData.business_no ? getRegMask(farmData.business_no) : null"
      />
      <v-text-field dense outlined
        class="textfield"
        id="phone" 
        ref="phone" 
        label="전화번호" 
        placeholder="숫자만 입력"
        v-model="farmData.phone"
        @keyup="farmData.phone ? getPhoneMask(farmData.phone) : null"
      />
    </div>

    <div class="mt-2 flex s-bt">
        <v-text-field dense outlined 
          class="textfield"
          id="email_id" 
          ref="email_id" 
          label="이메일" 
          v-model="farmData.email_id" 
        />
        <div class="mr-1">
          <img :src="mail" class="mt-5 icon"/>
        </div>
        <v-combobox dense outlined 
          id="email_host" 
          ref="email_host" 
          :items="['gmail.com','hotmail.com','naver.com','daum.net',]"
          :menu-props="{ top: false, offsetY: true }"
          placeholder="항목이 없으면 직접 입력하세요"
          v-model="farmData.email_host" 
        />
    </div>
    
    <div class="mt-5">
      <div class="flex">
        <v-text-field dense outlined
          disabled
          class="textfield"
          id="post_no" 
          ref="post_no" 
          label="우편번호✽" 
          v-model="farmData.post_no" 
          onKeyup="this.value=this.value.replace(/[^0-9]/g,'');"
          maxlength="5"
        />
        <v-btn text class="search_btn mt-1"
        @click="openPost()">
          검색
        </v-btn>
      </div>

      <div class="mt-2">
        <v-text-field dense outlined
        disabled
        style="min-width:525px;"
        class="textfield"
        id="address_1st" 
        ref="address_1st" 
        label="기본주소✽" 
        v-model="farmData.address_1st" 
        />
      </div>
      <div class="mt-2">
        <v-text-field dense outlined 
          style="min-width:525px;"
          class="textfield"
          id="address_last" 
          ref="address_last" 
          label="상세주소(빌딩명,동호수,상호)" 
          v-model="farmData.address_last" 
        />
      </div>

      <div class="flex mt-2">
        <v-text-field dense outlined
        disabled
        class="textfield"
        id="latitude" 
        ref="latitude"
        label="위도✽" 
        v-model="farmData.latitude" 
      />
      <v-text-field dense outlined
        disabled
        class="textfield"
        id="longitude" 
        ref="longitude"
        label="경도✽" 
        v-model="farmData.longitude" 
      />
    </div>
    
    <!--기타, 분뇨처리 축종일 시 필수값 x-->
    <div v-if="farmData.bizstatus.code !== 'CF99' ">
      <div class="flex mt-5">
        <v-text-field dense outlined 
          class="textfield"
          id="register_no" 
          ref="register_no" 
          :label="farmData.bizstatus.code !== 'CF99' ? '축산허가번호 ✽' : '축산허가번호'"
          v-model="farmData.register_no" 
        />

        <v-text-field dense outlined 
          class="textfield"
          id="etc3" 
          ref="etc3" 
          :label="farmData.bizstatus.code !== 'CF99' && farmData.bizstatus.code !== 'CF03' ? '축산업고유번호(5자) ✽' : '축산업고유번호(5자)'"
          placeholder="숫자+영문조합"
          v-model="farmData.etc3" 
        />
      </div>
    
      <!-- 이 아이 서비스 esg 선택했을때만 보여져야함. 이 부분은 검토-->
      <div class="mt-2 flex">
        <v-text-field dense outlined
          class="textfield"
          id="kepco_no" 
          ref="kepco_no" 
          :label="farmData.esg ? '한전고객번호 ✽' : '한전고객번호'"
          placeholder="전력사용량 사용 시 입력"
          v-model="farmData.kepco_no" 
        />
        
        <v-text-field dense outlined
          class="textfield" 
          id="farmUnique_no" 
          ref="farmUnique_no"
          :label="farmData.esg ? '농장식별번호 ✽' : '농장식별번호'"
          placeholder="ESG사용 시 입력 (숫자 6자리)"
          v-model="farmData.farmUnique_no" 
        />
      </div>
    </div>

      <div class="flex" v-if="(farmData.bizstatus.code == 'CF05' || farmData.bizstatus.code =='CF06')">
        <div class="cow_info"></div>
        <div class="cow_notice"> 농장식별번호-농장주생년월일로 입력해주세요</div>
      </div>

      <div class="mt-5 group-content">
        <div class="flex vertical-center">
          <h4 style="width:100px;">사용서비스</h4>
          <div class="flex" style="margin-top:-25px;">
            <v-checkbox label="출하/사육" v-model="farmData.trace" color="#005B96" disabled></v-checkbox>
            <!-- <v-checkbox label="관리일지" v-model="farmData.dailyrecord" color="#005B96" :disabled="this.$getters.userInfo.grade > 'UT02'"></v-checkbox> -->
            <v-checkbox label="환기제어" v-model="farmData.fancontrol" color="#005B96" disabled></v-checkbox>
            <v-checkbox label="악취제어" v-model="farmData.deodorizer" color="#005B96" disabled></v-checkbox>
            <v-checkbox label="ESG" v-model="farmData.esg" color="#005B96" disabled></v-checkbox>
          </div>
        </div>
      </div>

      <!-- 얘 축종 돼지 선택했을때만 보여져야함 -->
      <div class="mt-5 group-content" v-if="farmData.bizstatus.code == 'CF02'">
        <div class="flex radio-content">
          <div class="flex">
            <v-radio-group dense outlined row 
              id="owner_yn" 
              ref="owner_yn" 
              v-model="farmData.owner_yn">
                <template v-slot:label>
                  <div class="set_name"> 소유자 근무여부 </div>
                </template>
                <v-radio label="Y" value="Y" color="#005B96"/>
                <v-radio label="N" value="N" color="#88191a"/>    
            </v-radio-group>
          </div>

          <div class="flex">
            <v-radio-group dense outlined row 
              id="haccp_yn" 
              ref="haccp_yn" 
              v-model="farmData.haccp_yn"
            >
              <template v-slot:label>
                <div class="set_name"> HACCP 인증 </div>
              </template>
              <v-radio label="Y" value="Y" color="#005B96"/>
              <v-radio label="N" value="N" color="#88191a"/> 
            </v-radio-group>
          </div>
        </div>
       
        <div class="flex radio-content">
          <div class=flex>
            <v-radio-group dense outlined row
              id="disinfection_yn" 
              ref="disinfection_yn" 
              v-model="farmData.disinfection_yn"
            >
              <template v-slot:label>
                <div class="set_name"> 소독 여부 </div>
              </template>
              <v-radio label="Y" value="Y" color="#005B96"/>
              <v-radio label="N" value="N" color="#88191a"/> 
            </v-radio-group>
          </div>

            <div class="flex">
              <v-radio-group dense outlined row
                id="fumigator_yn" 
                ref="fumigator_yn" 
                v-model="farmData.fumigator_yn"
              >
                <template v-slot:label>
                  <div class="set_name"> 방역 여부 </div>
                </template>
                <v-radio label="Y" value="Y" color="#005B96"/>
                <v-radio label="N" value="N" color="#88191a"/> 
              </v-radio-group>
            </div>
          </div>
        </div>
      </div>

      <div class="hint-text">
        {{ farmData.hint }}
      </div>

      <div class="mt-5 flex vertical-center">
        <v-btn
            class="normal-btn mr-3"
            text
            :loading="loadingSave"
            id="save" 
            ref="save" 
            type="submit" 
            @click.prevent="save()"
          >
            저장
          </v-btn>
          <v-btn 
            class="new-btn"
            text
            id="newRegister" 
            ref="newRegister" 
            @click="resetFarmData()">
            새로등록
          </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import Apis from '@/api/apis'
import Common from "@/utils/custom/common.js";
import dateUtil from "@/utils/custom/dateProperty.js";
import timeZone_list from "@/components/json/timezone.json";

export default{
  name: 'Farm',
  props: {
    selectedItem: {
      type: Object,
      default: () => ({}),
    },
    selectedCompany: {
      type: [String, Object], // 데이터 유형에 따라 수정
      default: null,
    },
  },
  watch: {
    selectedItem: {
      immediate: true,
      handler(newValue) {
        if (newValue && Object.keys(newValue).length > 0) {
          this.farmData = { ...this.farmData, ...newValue }; 
        } else {
          this.resetFarmData(); 
        }
      },
    },
    selectedCompany: {
      immediate: true,
      handler(newValue, oldValue) {
        this.resetFarmData();
        if (newValue) {
          const company = this.companyItems.find(
            (item) => item.code === newValue
          );
          this.farmData.company = company || null;
        }
      },
    },
  },
  data: () => ({
    mail: require("@/assets/login/mail.svg"),


    farmData: {
      company: {},
      farm_name: '',

      bizstatus : {},
      biz_structure:'',
      // country: "Asia/Seoul",
      business_no:'',
      register_no:'',

      post_no: '',
      address_1st: '',
      address_last:'',

      longitude:'',
      latitude:'',

      email_id:'',
      email_host:'',

      phone:'',

      trace:false,
      // dailyrecord:false,
      fancontrol:false,
      deodorizer:false,
      esg:false,

      kepco_no:'',
      farmUnique_no:'',

      owner_yn: "",
      haccp_yn: "",
      disinfection_yn: "",
      fumigator_yn: "",

      // deldate:'',
      // history:'',
      hint:'',

      etc3:'',
    },
    timeZone_list:timeZone_list,

    bizstatusItems : Common.comboBaseCode("CF"),


    companyItems: [],
    loading: false,

    sameInfo: false, 

    businessDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    menu: false,
    modal: false,
    menu1: false,
    menu2: false,

    loadingSave: false,

    label_name: "사업장명✽",

  }),
  created() {
    this.loadDaumPostCode();
    this.loadKakaoMapAPI();
    this.comboCompanies();
  },
  methods:{
    save() {
      // console.log("checkdata", this.checkData());
      this.$store.commit("resMessage","");
      let msgCheckdata = this.checkData(); 
      if (msgCheckdata){
        this.$store.commit("resMessage",msgCheckdata);
        // alert(msgCheckdata);
        return;
      }
      this.loadingSave = true;
      if (this.farmData.farm_code) {
        // console.log("업데이트", this.farmData.farm.farm_cd);
        Apis.updateFarmFree({
          farm_cd: this.farmData.farm.farm_cd,
          company_cd: this.farmData.company?.code || null,
          farm_name: this.farmData.farm_name,
          business_no: this.farmData.business_no.replace(/[^0-9]/g, ''),
          biz_status: this.farmData.bizstatus.code, //경영형태
          reg_yn: 'Y',
          reg_no: this.farmData.register_no.trim(),
          kepco_no: this.farmData.kepco_no.trim(),
          post_no: this.farmData.post_no,
          address_1st: this.farmData.address_1st.trim(),
          address_last: this.farmData.address_last.trim(),
          latitude: Number(this.farmData.latitude),
          longitude: Number(this.farmData.longitude),
          email1: this.farmData.email_id.trim() + "@" + this.farmData.email_host, 
          email2: this.farmData.biz_structure,
          phone1: this.farmData.phone.replace(/[^0-9]/g, ''),
          phone2: "",
          owner_yn: this.farmData.owner_yn,
          haccp_yn: this.farmData.haccp_yn,
          disinfection_yn: this.farmData.disinfection_yn,
          fumigator_yn: this.farmData.fumigator_yn,
          // deldate: '',
          // history: '',
          // etc1: "Asia/Seoul",
          etc2: this.farmData.farmUnique_no.replaceAll(' ', ''),
          etc3: this.farmData.etc3,
          trace: this.farmData.trace,
          // dailyrecord: this.farmData.dailyrecord,
          fancontrol: this.farmData.fancontrol,
          deodorizer: this.farmData.deodorizer,
          reserve1: this.farmData.esg,
          },(res) => {  
            if (res.result) {
              this.loadingSave = false;
              this.$store.commit("resMessage",res.message);

              this.$emit("refreshTreeData");
              this.resetFarmData();

              // console.log('업데이트 완료');
              // this.listFarms();
            } else {
              this.loadingSave = false;
              alert(res.message);
            }
          }).catch( (err) => {  // API 오류 처리
              this.loadingSave = false;
              console.log("updateFarm API 호출 오류",err)
              alert(err);
          }
        )
      } else {
        // console.log("인서트");
        Apis.insertFarm({
          company_cd: this.farmData.company?.code || null,
          farm_name: this.farmData.farm_name,
          
          business_no: this.farmData.business_no.replace(/[^0-9]/g, ''),
          biz_status: this.farmData.bizstatus.code,

          reg_yn: 'Y',
          reg_no: this.farmData.register_no.trim(),
          kepco_no: this.farmData.kepco_no.trim(),

          post_no: this.farmData.post_no,
          address_1st: this.farmData.address_1st.trim(),
          address_last: this.farmData.address_last.trim(),

          latitude: Number(this.farmData.latitude),
          longitude: Number(this.farmData.longitude),

          email1: this.farmData.email_id.trim() + "@" + this.farmData.email_host, 
          email2: this.farmData.biz_structure, //경영형태
          phone1: this.farmData.phone.replace(/[^0-9]/g, ''),
          phone2: "",

          owner_yn: this.farmData.owner_yn,
          haccp_yn: this.farmData.haccp_yn,
          disinfection_yn: this.farmData.disinfection_yn,
          fumigator_yn: this.farmData.fumigator_yn,
          // deldate: '',
          // history: '',

          // etc1: "Asia/Seoul",
          etc2: this.farmData.farmUnique_no.replaceAll(' ', ''),
          etc3: this.farmData.etc3,

          trace : this.farmData.trace,
          // dailyrecord: this.farmData.dailyrecord,
          fancontrol: this.farmData.fancontrol,
          deodorizer: this.farmData.deodorizer,
          reserve1: this.farmData.esg,
          },(res) => {  
            if (res.result) {
              this.loadingSave = false;
              this.$store.commit("resMessage",res.message);

              this.$emit("refreshTreeData");
              this.resetFarmData();
              // this.listFarms();
            } else {
              this.loadingSave = false;
              alert(res.message);
            }
          }).catch( (err) => {  // API 오류 처리
              this.loadingSave = false;
              console.log("insertFarm API 호출 오류",err)
              alert(err);
          }
        )
      }
    },
    resetFarmData() {
      // console.log('리셋')

      this.farmData = {
        company: this.selectedCompany ? { ...this.selectedCompany } : null,

        bizstatus:{},

        farm_name: '',
        sameInfo: false,

        // country: null,
        biz_structure:'',
        business_no:'',
        register_no:'',
        
        post_no: '',
        address_1st: '',
        address_last:'',
        latitude:'',
        longitude:'',

        email_id:'',
        email_host:'',
        
        phone:'',

        trace:false,
        // dailyrecord:false,
        fancontrol:false,
        deodorizer:false,
        esg:false,

        kepco_no:'',
        farmUnique_no:'',

        owner_yn: "",
        haccp_yn: "",
        disinfection_yn: "",
        fumigator_yn: "",

        // deldate:'',
        // history:'',
        hint:'',

        etc3:'',
        email2 : '',

      };
    },
    checkData() {
      // if (!this.farmData.company_cd) {
      //   this.$refs.company.focus();
      //   return "상위 경영체를 선택입력하세요";
      // }
      if (!this.farmData.bizstatus.code) {
        this.$refs.bizstatus.focus();
        return "업태를 선택입력하세요";
      }
      if (!this.farmData.farm_name.trim()) {
        this.$refs.farm_name.focus();
        return "사업장(농장/사업장)명을 입력하세요";
      }
      if(this.farmData.bizstatus.code == 'CF02'){
        if(!this.farmData.biz_structure){
          this.$refs.biz_structure.focus();
          return "경영형태를 선택하세요";
        }
      }
      // if (this.farmData.business_no.trim()) {
      //   if (!(Common.checkBizNo(this.farmData.business_no)) && !(Common.checkRegNo(this.farmData.business_no))) {
      //     this.$refs.business_no.focus();
      //     return "사업자/법인 등록번호가 유효하지 안습니다.";
      //   }  
      // }  
      // if (!this.farmData.country) {
      //   this.$refs.country.focus();
      //   return "해당 농장의 국가를 선택하세요";
      // }
      if (!this.farmData.address_1st.trim()) {
        this.$refs.address_1st.focus();
        return "기본주소를 입력하세요";
      }
      if (!Common.isNumeric(this.farmData.latitude)) {
        this.$refs.latitude.focus();
        return "위도 좌표를 구글 지도등에서 확인후 입력하세요";
      }
      if (Number(this.farmData.latitude) > 38.6144 || Number(this.farmData.latitude) < 33.167884)   {
        this.$refs.latitude.focus();
        return "위도 범위가 아닙니다";
      }
      if (!Common.isNumeric(this.farmData.longitude)) {
        this.$refs.longitude.focus();
        return "경도 좌표를 구글 지도등에서 확인후 입력하세요";
      }
      if (Number(this.farmData.longitude) > 130.919948 || Number(this.farmData.longitude) < 125.36977)   {
        this.$refs.longitude.focus();
        return "경도 범위가 아닙니다";
      }
      if(this.farmData.esg && (this.farmData.bizstatus.code == 'CF05' || this.farmData.bizstatus.code =='CF06')){
        if (!this.farmData.farmUnique_no.includes('-')){
          this.$refs.farmUnique_no.focus();
          return "소 농가의 경우 농장식별번호-농장주생년월일로 입력하세요.";
        }
      }
      if(this.farmData.bizstatus.code == 'CF03'){
        if (!this.farmData.register_no.trim()) {
          this.$refs.register_no.focus();
          return "축산허가번호를 입력하세요";
        }
      }
      if(this.farmData.bizstatus.code !== 'CF03' && this.farmData.bizstatus.code !== 'CF99'){
        if (!this.farmData.register_no.trim()) {
          this.$refs.register_no.focus();
          return "축산허가번호를 입력하세요";
        }
        if (!this.farmData.etc3.trim()) {
          this.$refs.etc3.focus();
          return "축산업 고유번호를 입력하세요";
        }
      }
      if(this.farmData.esg){
        if (!this.farmData.kepco_no.trim()) {
          this.$refs.kepco_no.focus();
          return "한전 고객 번호를 입력하세요";
        }
        if (!this.farmData.farmUnique_no.trim()) {
          this.$refs.farmUnique_no.focus();
          return "농장 식별 번호를 입력하세요";
        }
      }
      if(this.farmData.trace){
        if (!this.farmData.farmUnique_no.trim()) {
          this.$refs.farmUnique_no.focus();
          return "농장 식별 번호를 입력하세요";
        }
      }
      // if (!this.farmData.phone.trim()) {
      //   this.$refs.phone.focus();
      //   return "전화번호를 입력하세요";
      // }
      return "";
      },
    check(){
      if (this.sameInfo) {
        this.farmData.farm_name = this.farmData.company.name || '';
      } else {
        this.farmData.farm_name = '';
      }
    },
    // comboTimeZone(){
    //   if(this.timeZone_list && this.timeZone_list.timeZone){
    //     this.country = {name : this.country.name, timezone:this.country.timeZone}
    //   }
    //   // console.log(this.country)
    // },
    comboCompanies() {
      Apis.comboCompanies({
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"), 
        },(res) => {  
          if (res.result) {
            this.companyItems = [];

            // console.log(res.data);
            for (let i in res.data) {
            this.companyItems.push({
              code: res.data[i].company_cd,
              name: res.data[i].company_name,
              });
            }  
          } else {
            alert(res.message);
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("API 호출 오류",err)
            alert(err);
        }
      ) 
    },
    updateSelectedCompany(selectedCompany) {
      this.$emit("update:selectedCompany", selectedCompany?.code || null);
    },
    infoDetail(value) {

      this.loading = true;
      Apis.infoFarm({
          farm_cd: value.farm_cd,
        },(res) => {
          if (res.result) {
            // console.log(resn.data)

            let email_id = "";
            let email_host = "";

            if (res.data.email1) {
                const email = res.data.email1.split("@", 2);
                email_id = email[0] || ""; 
                email_host = email[1] || ""; 
            }

            this.farmData = {
              ...this.farmData,

              bizstatus : res.data.biz_status,
              company: this.companyItems.find(
                (item) => item.code === this.selectedCompany
              ) || null,
              farm_code: res.data.farm_cd,
              farm_name: res.data.farm_name,

              // country: res.data.etc1,
              business_no:Common.getRegMask(res.data.business_no),
              register_no:res.data.reg_no,
              
              post_no: res.data.post_no,
              address_1st: res.data.address_1st,
              address_last: res.data.address_last,

              latitude: res.data.latitude,
              longitude: res.data.longitude,

              email_id: email_id,
              email_host: email_host,

              phone: Common.getMask(res.data.phone1),

              trace: res.data.trace,
              // dailyrecord:res.data.dailyrecord,
              fancontrol:res.data.fancontrol,
              deodorizer:res.data.deodorizer,
              esg:res.data.reserve1,

              kepco_no:res.data.kepco_no,
              farmUnique_no:res.data.etc2,

              owner_yn: res.data.owner_yn,
              haccp_yn: res.data.haccp_yn,
              disinfection_yn: res.data.disinfection_yn,
              fumigator_yn: res.data.fumigator_yn,

              // deldate:res.data.deldate,
              // history:res.data.history,
              hint: res.data.regdate + "에 등록, " + res.data.chguser + "님이 " + res.data.chgdate + "에 최종 수정",

              //축산업등록번호
              etc3:res.data.etc3,
              //경영형태
              biz_structure : res.data.email2,
              
            };
            this.loading = false;
          } else {
            this.loading = false;
            alert(res.message);
          }
        }
      );
    },
    
    loadDaumPostCode() {
      return new Promise((resolve, reject) => {
        if (window.daum && window.daum.Postcode) {
          resolve();
        } else {
          const daumScript = document.createElement('script');
          daumScript.src = '//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
          daumScript.async = true;

          daumScript.onload = () => resolve();
          daumScript.onerror = () => reject(new Error('Failed to load Daum Postcode API.'));
          document.head.appendChild(daumScript);
        }
      });
    },
    loadKakaoMapAPI() {
      return new Promise((resolve, reject) => {
        if (window.kakao && kakao.maps && kakao.maps.services) {
          kakao.maps.load(() => resolve());
        } else {
          const kakaoScript = document.createElement('script');
          kakaoScript.src = 'https://dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=84904cd1cc1af1bd9ff7067996ed7dd2&libraries=services';
          kakaoScript.async = true;

          kakaoScript.onload = () => {
            kakao.maps.load(() => resolve());
          };
          kakaoScript.onerror = () => reject(new Error('Failed to load Kakao Maps API.'));
          document.head.appendChild(kakaoScript);
        }
      });
    },
    openPost() {
      this.loadDaumPostCode()
        .then(() => {
          // console.log('Daum Postcode API loaded.');
          new daum.Postcode({
            oncomplete: (data) => {
              // 1. 주소 결과를 farmData에 저장
              this.farmData.post_no = data.zonecode; // 우편번호
              this.farmData.address_1st = data.roadAddress; // 기본주소
              // console.log('Address:', data.roadAddress);

              // 2. Kakao Maps Geocoder로 주소 검색
              this.loadKakaoMapAPI()
                .then(() => {
                  // console.log('Kakao Maps API loaded.');
                  kakao.maps.load(() => {
                    const geocoder = new kakao.maps.services.Geocoder();
                    geocoder.addressSearch(data.roadAddress, (result, status) => {
                      if (status === kakao.maps.services.Status.OK) {
                        // 3. 위도, 경도를 farmData에 저장
                        this.farmData.latitude = result[0].y;
                        this.farmData.longitude = result[0].x;
                        // console.log('Latitude:', result[0].y, 'Longitude:', result[0].x);
                      } else {
                        console.error('Geocoding failed:', status);
                      }
                    });
                  });
                })
                .catch((error) => {
                  console.error('Kakao Maps API 로드 실패:', error.message);
                });
            },
          }).open();
        })
        .catch((error) => {
          console.error('Daum Postcode API 로드 실패:', error.message);
        });
    },

    getPhoneMask(val) {
      // console.log(val)
      this.farmData.phone = Common.getMask(val)
    },
    getRegMask(val) {
      // let res = Common.getRegMask(val)
      this.farmData.business_no = Common.getRegMask(val)
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../info_style/info_style.scss';
h4{
  text-align: center;
}
.notice__info{
  font-size:12px;
  letter-spacing: -1px;
  color:#939393;
  margin-top:3px;
}
.group-content{
  border: 1px solid #E9E9E9;
  padding:10px;
  border-radius: 10px;
}
.radio-content{
  margin-left:15px;
  height:45px;
  margin-top:-15px;
}
.set_name{
  width:100px;
}
.v-input__control .v-input__messages {
  color:red;
  display: block !important; /* 힌트 강제 표시 */
}
.cow_info{
  width:270px;
  margin-right:5px;
}
.cow_notice{
  font-size:12px;
  letter-spacing: -0.75px;
  color:rgb(190, 0, 0);
}
::v-deep .biz_text .v-select__selection--comma{
  overflow: hidden !important;
  white-space: nowrap !important;
  text-overflow: clip !important;

  font-size:14px !important;
  letter-spacing: -1px;
  margin:0 !important; 
}
</style>
